// @flow
/**
 * Teadete haldamise store
 */
import alt from '../alt';
import NotificationActions from '../actions/NotificationActions';

class NotificationStore {
	constructor() {
		this.notifications = [];
		this.bindActions(NotificationActions);
	}
	
	onInfo(message) {
		this.notifications.push({
			type: 'info',
			message: message,
			timeout: 3000
		});
	}
	
	onWarning(message) {
		this.notifications.push({
			type: 'warning',
			message: message
		});
	}
	
	onSuccess(message) {
		this.notifications.push({
			type: 'success',
			message: message,
			timeout: 3000
		});
	}
	
	onError(message) {
		this.notifications.push({
			type: 'danger',
			message: message
		});
	}
	
	onDismiss(item) {
		this.notifications.splice(item.key, 1);
	}

	onClear() {
		this.notifications = [];
	}
}

export default alt.createStore(NotificationStore, 'NotificationStore');
